class collectionFilters extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector('.product-grid');
    this.form = document.querySelector('.filters-form');

    this.dropdownButtons = document.querySelectorAll('.collection-filters__dropdown-button');
    this.filterButtons = document.querySelectorAll('.collection-filters__filter-button');

    this.openFilterButtons = document.querySelectorAll('.js-open-filters');
    this.closeFilterButtons = document.querySelectorAll('.js-close-filters');
    this.sortBy = this.dataset.currentSort || '';
    this.handleOverlayClick = this.handleOverlayClick.bind(this);

    this.setListeners();
  }

  setListeners() {
    // Handle Dropdown Click
    this.dropdownButtons.forEach(item => {
      item.addEventListener('click', this.handleDropdownClick);
    });

    // Handle Form Change
    this.form.addEventListener('change', event => {
      if (event.target.classList.contains('sort-by')) {
        this.handleSortClick(event.target);
      } else {
        this.handleFilterClick(event.target);
      }
    });

    this.form.addEventListener('submit', event => {
      event.preventDefault();
    });

    // Handle Remove Filter
    this.addEventListener('click', event => {
      const button = event.target.closest('.remove-filter');
      if (button) {
        event.preventDefault();
        const filter = button.dataset.filter;
        const initial = button.dataset.url;
        const newUrl = window.location.protocol + '//' + window.location.host + initial;

        if (filter) {
          this.removeSelectedFilter(filter);
          this.reloadSections(newUrl);
        } else {
          window.location.href = newUrl;
        }
      }
    });

    // Clear All Filters
    this.addEventListener('click', event => {
      const button = event.target.closest('.js-clear-all-filters');
      if (button) {
        this.clearAllFilters(event);
      }
    });

    // Open
    this.openFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        this.open(event);
      });
    });

    // Close
    this.closeFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        this.close(event);
      });
    });
  }

  open(event) {
    if (event) event.preventDefault();
    const overlay = this.getOverlayElement();

    document.querySelector('.collection-filters__slideout').classList.add('active');
    document.body.classList.add('scroll-lock');

    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.addEventListener('click', this.handleOverlayClick);
    }
  }

  close(event) {
    if (event) event.preventDefault();
    const overlay = this.getOverlayElement();

    document.querySelector('.collection-filters__slideout').classList.remove('active');
    document.body.classList.remove('scroll-lock');

    if (overlay) overlay.classList.remove('is-visible');

    this.closeAllDropdowns();
  }

  handleOverlayClick() {
    this.close();
  }

  handleDropdownClick(event) {
    event.preventDefault();

    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }

  handleFilterClick() {
    this.reloadSections();
  }

  removeSelectedFilter(filter) {
    const input = document.querySelector(`.collection-filters__filter-button[data-filter="${filter}"]:checked`);
    if (input) input.checked = false;
  }

  handleSortClick(target) {
    const sort = target.value;
    const sortText = target.dataset.name;
    const sortTextDestination = this.querySelector('.collection-filters__dropdown-active-sort');

    this.sortBy = sort;
    if (sortTextDestination) sortTextDestination.innerHTML = sortText;

    this.closeAllDropdowns();
    this.reloadSections();
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach(button => {
      if (button.classList.contains('active')) {
        button.classList.remove('active');
      }
    });
  }

  clearAllFilters(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    document.querySelectorAll('.collection-filters__filters .collection-filters__filter-button').forEach(item => {
      // Must clear the property, not the attribute - a shopper's click sets
      // the property and removeAttribute() leaves it untouched.
      item.checked = false;
    });

    // Clear price range
    const priceMin = this.querySelector('.price-range__input-field--min');
    const priceMax = this.querySelector('.price-range__input-field--max');
    if (priceMin) priceMin.value = '';
    if (priceMax) priceMax.value = '';

    this.closeAllDropdowns();
    this.reloadSections('clear');

    this.close();
  }

  buildUrl(newUrl) {
    if (newUrl === 'clear') return location.pathname;

    const params = new URLSearchParams();
    new FormData(this.form).forEach((value, key) => {
      // Drop empty price bounds rather than emitting `filter.v.price.gte=`.
      if (value !== '') params.append(key, value);
    });

    if (this.sortBy) params.set('sort_by', this.sortBy);

    let hasAvailability = false;
    params.forEach((value, key) => {
      if (key.indexOf('filter.v.availability') === 0) hasAvailability = true;
    });
    if (!hasAvailability) params.set('filter.v.availability', '1');

    const query = params.toString();
    return query ? `${location.pathname}?${query}` : location.pathname;
  }

  reloadSections(newUrl) {
    const url = this.buildUrl(newUrl);

    if (history.replaceState) {
      window.history.pushState({ path: url }, '', url);
    }

    // Fetch and replace sections
    this.enableLoading();
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const htmlContent = new DOMParser().parseFromString(html, 'text/html');

        this.getSectionsToRender().forEach((section => {
          const target = document.getElementById(section.id);
          const source = htmlContent.getElementById(section.id);
          if (target && source) target.innerHTML = source.innerHTML;
        }));

        const dropdownContents = this.querySelectorAll('.collection-filters__dropdown-container');
        dropdownContents.forEach(content => {
          if (content.classList.contains('collection-filters__dropdown-container--price-range')) return;
          const newContent = htmlContent.getElementById(content.id);
          if (newContent) content.innerHTML = newContent.innerHTML;
        });

        this.disableLoading();
      })
      .catch((error) => {
        console.error('[collection-filters] Failed to reload sections:', error);
        this.disableLoading();
      })
      .finally(() => {
        document.querySelectorAll('.product-grid__item.fade-in').forEach(item => item.style.opacity = 1);
      });
  }

  getSectionsToRender() {
    return [
      { id: 'product-grid' },
      { id: 'active-filters' },
      { id: 'active-filters-bar' },
      { id: 'apply-product-count' },
      { id: 'main-product-count' }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    // this.grid.classList.add('loading');
  }

  disableLoading() {
    // this.grid.classList.remove('loading');
  }

  getOverlayElement() {
    if (window.innerWidth < 951) {
      return document.querySelector('.page-overlay');
    } else {
      return document.querySelector('.page-overlay-under-menu');
    }
  }
}

customElements.define('collection-filters', collectionFilters);

class PriceRange extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
    this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
    this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
    this.textInputHigherBound = this.querySelector('.price-range__input:last-child input');
    this.textInputLowerBound.addEventListener('focus', () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener('focus', () => this.textInputHigherBound.select());
    this.textInputLowerBound.addEventListener('change', (event) => {
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      this.rangeLowerBound.value = event.target.value;
      this.rangeLowerBound.parentElement.style.setProperty('--range-min', `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
    });
    this.textInputHigherBound.addEventListener('change', (event) => {
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      this.rangeHigherBound.value = event.target.value;
      this.rangeHigherBound.parentElement.style.setProperty('--range-max', `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
    });
    this.rangeLowerBound.addEventListener('change', (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.rangeHigherBound.addEventListener('change', (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.rangeLowerBound.addEventListener('input', (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty('--range-min', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputLowerBound.value = event.target.value;
    });
    this.rangeHigherBound.addEventListener('input', (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      this.textInputHigherBound.value = event.target.value;
    });
  }
};

window.customElements.define('price-range', PriceRange);
